import superagent from 'superagent'

const route = {
  // Shortest route along the trail/road network between two points.
  // Resolves the API's GeoJSON Feature; rejects with err.status 404 when no route exists.
  get: ({ startLat, startLng, endLat, endLng, token }) => {
    return new Promise((resolve, reject) => {
      const coords = [startLat, startLng, endLat, endLng].map(Number)
      if (coords.some(isNaN)) {
        reject()
        return
      }
      superagent
        .get(`${__API_URI__}/Route/Get?startLatitude=${startLat}&startLongitude=${startLng}&endLatitude=${endLat}&endLongitude=${endLng}`)
        .set('Authorization', `Bearer ${token}`)
        .set('content-type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            reject(err)
          } else {
            resolve(res.body)
          }
        })
    })
  },

  // Route through ordered waypoints [{lat, lng}, ...] (2-25 points).
  // Resolves the API's GeoJSON Feature; rejects with the superagent error (err.status 404
  // when no route connects every pair; a 400's body is { error, error_description, leg }).
  // Options:
  //   includeDirections: the Feature's properties carry a turn-by-turn "steps" array.
  //   quick: drag previews; the API skips its slow fallback / solves off-trail coarser.
  //   mode: 'drive' | 'hike' (API-3821). Drive never routes on foot; under it, trails
  //     are motorized trails. With a mode, layers is always sent explicitly.
  //   layers: Route Prefers networks, a subset of ['main','usfs','trails'], or ['none']
  //     for an off-trail path that follows nothing.
  //   offTrail: with mode 'hike', a cross-country path over the terrain that uses the
  //     ticked networks where they help (API-3822).
  // The timeout keeps a hung request from wedging drag throttling.
  getVia: (points, token, { includeDirections = false, quick = false, layers = null, mode = null, offTrail = false } = {}) => {
    return new Promise((resolve, reject) => {
      if (!Array.isArray(points) || points.length < 2) {
        reject()
        return
      }
      const params = [
        includeDirections ? 'includeDirections=true' : '',
        quick ? 'quick=true' : '',
        mode ? `mode=${mode}` : '',
        mode === 'hike' && offTrail ? 'offTrail=true' : '',
        Array.isArray(layers) && layers.length ? `layers=${layers.join(',')}` : ''
      ].filter(Boolean).join('&')
      superagent
        .post(`${__API_URI__}/Route/Get${params ? `?${params}` : ''}`)
        .timeout({ response: 10000, deadline: 15000 })
        .send(points.map(p => ({ latitude: p.lat, longitude: p.lng })))
        .set('Authorization', `Bearer ${token}`)
        .set('content-type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            reject(err)
          } else {
            resolve(res.body)
          }
        })
    })
  }
}

export default route
